module.exports = __webpack_public_path__ + "static/media/mika-matin.c9f1c095.jpg";